import { Transition } from '@unseenco/taxi'
import { animate, createTimeline, cubicBezier } from 'animejs';


// --- HTML class helpers ---

const colorCache = new Map();
const BG_CLASSES = ['bg-green', 'bg-blue', 'bg-orange', 'bg-white', 'bg-black'];

// Tracks the URL of the page we're currently ON — updated in onEnter after each
// navigation so onLeave always has the correct "from" URL even during popstate,
// where window.location.href has already changed to the destination.
let trackedUrl = window.location.href;
const siteLoader = document.getElementById('siteLoader');
const MOBILE_BREAKPOINT = 740;
const EASE = cubicBezier(0.358, 0.002, 0, 1);


function scrollToTop() {
  window.scrollTo(0, 0);
  document.documentElement.scrollTop = 0;
  document.body.scrollTop = 0; // Safari fallback
}




function setHTMLBgClass(cls) {
  document.documentElement.classList.remove(...BG_CLASSES);
  document.documentElement.classList.add(cls);
}

function updateHTMLClass(trigger) {
  if (trigger instanceof HTMLElement) {
    const color = trigger.dataset.color;
    setHTMLBgClass(color + 'hi' || 'bg-white');
    if (color) colorCache.set(trigger.href, color);
  }
}

function restoreHTMLClass() {
  const color = colorCache.get(window.location.href);
  if (color) setHTMLBgClass(color);
}

function fadeOutWorkHeader() {
  const header = document.querySelector('.work-grid-header');
  if (!header || header.style.display === 'none') return;
  animate(header, {
    opacity: [1, 0],
    duration: 200,
    easing: EASE,
    onComplete: () => { header.style.display = 'none'; },
  });
}

function basicOnEnterTransition(to, done) {
  to.style.opacity = '0';
  // window.scrollTo(0, 0);
  animate(to, {
    opacity: [0, 1],
    duration: 650,
    easing: 'easeInOutQuad',
    onComplete: () => {
      to.style.opacity = '';
      done();
    }
  });
}

// --- Transition classes ---
export class DefaultTransition extends Transition {
  onLeave({ from, trigger, done }) {
    fadeOutWorkHeader();

    // Cache the leaving page's bg class keyed to trackedUrl (not window.location.href,
    // which may already point to the destination during popstate/back navigation)
    const currentBg = BG_CLASSES.find(cls => document.documentElement.classList.contains(cls)) || 'bg-white';
    colorCache.set(trackedUrl, currentBg);

    const color = trigger instanceof HTMLElement ? trigger.dataset.color : null;

    siteLoader.style.display = 'block';
    siteLoader.classList.remove(...BG_CLASSES);
    if (color) siteLoader.classList.add(color);

    createTimeline()
    .add('.site-loader', {
      opacity: [0, 1],
      duration: 400,
      easing: EASE,
      onStart: () => {
        if (color) setHTMLBgClass(color);
      }
    })
    .add(from, {
      opacity: [1, 0],
      duration: 0,
      delay: 400,
      easing: EASE,
      onComplete: done
    });
  }

  onEnter({ to, done }) {
    trackedUrl = window.location.href;
    restoreHTMLClass();
    window.scrollTo({ top: 0, behavior: 'instant' });
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0; // Safari fallback

    createTimeline()
    .add('.site-loader', {
      opacity: [1, 0],
      duration: 600,
      easing: EASE,
      onComplete: () => {
        siteLoader.style.display = 'none';
      }
    })
    .add(to, { 
      opacity: [0, 1], 
      duration: 0, 
      onComplete: done 
    });

    // animate(to, { opacity: [0, 1], duration: 650, delay: 250, easing: EASE, onComplete: done });
  }
}

export class WorkToWorkTransition extends Transition {
  onLeave({ from, done }) {
    const form = document.querySelector('.work-grid-header form');
    if (from.dataset.taxiView === 'workGrid') {
      if (form) animate(form, { opacity: [1, 0], duration: 500, easing: 'easeInOutQuad' });
    } else if (from.dataset.taxiView === 'workList') {
      if (form) {
        form.style.visibility = '';
        animate(form, { opacity: [0, 1], duration: 500, easing: 'easeInOutQuad' });
      }
    }
    animate(from, { opacity: [1, 0], duration: 350, easing: 'easeInOutQuad', onComplete: done });
  }

  onEnter({ to, done }) {
    scrollToTop();
    basicOnEnterTransition(to, done);
  }
}














/* OLD 

export class HomeToProjectTransition extends Transition {
  onLeave({ from, trigger, done }) {
    // alert('homeptopagroj');
    console.log('to', trigger);
    updateHTMLClass(trigger);
    animate(from, { opacity: [1, 0],  duration: 350, easing: EASE, onComplete: done});
    // framePushOutProject(from, done);
  }

  onEnter({ to, done }) {
    restoreHTMLClass();
    animate(to, { opacity: [0, 1], duration: 650, easing: EASE, onComplete: done });
    // basicOnEnterTransition(to, done);
  }
}


export class WorkToProjectTransition extends Transition {
  onLeave({ from, trigger, done }) {
    fadeOutWorkHeader();
    updateHTMLClass(trigger);
    animate(from, { opacity: [1, 0], duration: 500, easing: EASE, onComplete: done });
    // frameWorkToProject(from, done);
  }

  onEnter({ to, done }) {
    animate(to, {
      opacity: [0, 1],
      duration: 0,
      easing: 'easeInOutQuad',
      onComplete: () => {
        to.style.opacity = '';
        done();
      }
    });
  }
}

export class HomeToWorkTransition extends Transition {
  onLeave({ from, done }) {
    setHTMLBgClass('bg-white');
    // framePushOut(from, done);
  }

  onEnter({ to, done }) {
    animate('.frame-strip.left',  { translateX: 0, opacity: 1, duration: 0 });
    animate('.frame-strip.right', { translateX: 0, opacity: 1, duration: 0 });
    basicOnEnterTransition(to, done);
  }
}


export class AboutTransition extends Transition {
  onLeave({ from, done }) {
    // alert('about');
    fadeOutWorkHeader();
    setHTMLBgClass('bg-white');
    // framePushOut(from, done);
  }

  onEnter({ to, done }) {
    basicOnEnterTransition(to, done);
  }
}

export class HomeOldTransition extends Transition {
  onLeave({ from, done }) {
    fadeOutWorkHeader();
    setHTMLBgClass('bg-black');
    // framePullIn(from, done);
  }

  onEnter({ done }) {
    document.querySelector('.static-overlay').classList.add('is-visible-important');
    window.scrollTo(0, 0);
    done();
  }
}

/*
export class HomeToProjectTransition extends Transition {
  onLeave({ from, trigger, done }) {
    updateHTMLClass(trigger);
    framePushOutProject(from, done);
  }

  onEnter({ to, done }) {
    restoreHTMLClass();
    basicOnEnterTransition(to, done);
  }
}

export class ProjectToHomeTransition extends Transition {
  onLeave({ from, done }) {
    setHTMLBgClass('bg-white');
    // framePullInProject(from, done);
  }

  onEnter({ to, done }) {
    basicOnEnterTransition(to, done);

    animate('.hp-card', {
      opacity: [0, 1],
      scale: [0.62, 1],
      duration: 500,
      delay: 700,
      easing: EASE,
    });
  }
}

export class WorkToAboutTransition extends Transition {
  onLeave({ from, done }) {
    fadeOutWorkHeader();
    setHTMLBgClass('bg-white');
    // framePushOut(from, done);
    
    // const tl = createTimeline({ autoplay: false, defaults: { easing: 'easeOutExpo' } });
   //  tl.add(from, { opacity: [1, 0], duration: 500, easing: 'easeInOutQuad', onComplete: done }, 0);
  }

  onEnter({ to, done }) {
    basicOnEnterTransition(to, done);
  }
}

export class AboutToWorkTransition extends Transition {
  onLeave({ from, done }) {
    // frameAboutToWork(from, done);
  }

  onEnter({ to, done }) {
    basicOnEnterTransition(to, done);
  }
}

export class ProjectToAboutTransition extends Transition {
  onLeave({ from, done }) {
    // animate('.frame-strip.left, .frame-strip.right', { opacity: [1, 0], duration: 0 });
    setHTMLBgClass('bg-white');
    animate(from, { opacity: [1, 0], duration: 650, easing: 'easeInOutQuad', onComplete: done });
  }

  onEnter({ to, done }) {
    basicOnEnterTransition(to, done);
  }
}

*/